// extracted by mini-css-extract-plugin
export default {"filterContainer":"Favorites_filterContainer__cF4PC","divPrincipal":"Favorites_divPrincipal__hkUw+"};